import type { DSFlagName } from "@/src/design_system/primitives/flag/types/flagName";
import type { DSPaletteItemSurface } from "@/src/design_system/data_display/palette_item/types";
import { ObjectValues } from "@/src/shared/types/objectValues";

export interface NormalizedBaseInputAffix {
  icon?: string | null;
  text?: string | null;
  flag?: DSFlagName | null;
  avatarUrl?: string | null;
  swatch?: DSPaletteItemSurface;
}

export type BaseInputAffix = NormalizedBaseInputAffix | string;

export const DS_BASE_INPUT_AFFIX_TYPE = {
  Prefix: "prefix",
  Suffix: "suffix",
};

export type DSBaseInputAffixType = ObjectValues<typeof DS_BASE_INPUT_AFFIX_TYPE>;

export type {
  DSBaseInputSlots,
  DSBaseInputValueSlotInputAttrs,
  DSBaseInputValueSlotProps,
} from "@/src/design_system/form_elements/base_input/types/dsBaseInput";
